import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#D8FFFF" d="M99 40.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="M96.26 65.63c-.38 0-.77-.15-1.06-.44a1.49 1.49 0 0 1 0-2.12l9.99-9.99a1.49 1.49 0 0 1 2.12 0c.59.59.59 1.54 0 2.12l-9.99 9.99c-.29.29-.68.44-1.06.44"
    />
    <path
      fill="#00D8D8"
      d="M106.25 65.63c-.38 0-.77-.15-1.06-.44L95.2 55.2a1.49 1.49 0 0 1 0-2.12 1.49 1.49 0 0 1 2.12 0l9.99 9.99c.59.59.59 1.54 0 2.12-.29.29-.68.44-1.06.44"
    />
    <path fill="#D8FFFF" d="M96.5 87a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      d="M12.02 60.85c-.83 0-1.5-.67-1.5-1.5V45.22c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v14.13c0 .83-.67 1.5-1.5 1.5"
    />
    <path
      fill="#00D8D8"
      d="M19.09 53.78H4.95c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h14.13c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM23 25c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M58 88c16.57 0 30-13.43 30-30S74.57 28 58 28 28 41.43 28 58s13.43 30 30 30"
    />
    <path
      fill="#001A43"
      d="M48 53c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3M68 53c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3M58 78.25c-7.92 0-15.02-4.41-18.54-11.5-.55-1.11-.1-2.46 1.02-3.02 1.11-.55 2.46-.1 3.02 1.02 2.75 5.55 8.31 9 14.5 9s11.75-3.45 14.5-9c.55-1.11 1.9-1.57 3.02-1.02 1.11.55 1.57 1.9 1.02 3.02-3.52 7.09-10.62 11.5-18.54 11.5"
    />
  </svg>
);
const SvgEnrichedIconHappyBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconHappyBrand);
export default Memo;
